export default "__VITE_ASSET__5c719045__"